import dynamic from 'next/dynamic';

const ContactFormWithHelperText = dynamic(() => import('./ContactFormWithHelperText'), { ssr: false });

export default ContactFormWithHelperText;
